import React from "react";
import { Container, Navbar } from "react-bootstrap";

import { Tooltip } from "components";
import { URLS } from "globalConstants";

import SearchForm from "./searchForm";
import UserProfileBar from "./userProfileBar";

import { ReactComponent as BookIcon } from "static/images/book.svg";
import { ReactComponent as QuestionIcon } from "static/images/question.svg";
import styles from "./header.module.scss";

const Header = () => (
	<Navbar className={styles.header}>
		<Container fluid>
			<ul className="d-flex flex-nowrap list-unstyled mb-0">
				<li className={`${styles.logoHolder} ${styles.prcLogo}`}>
					<a
						href={URLS.toPrc}
						className="d-block"
						target="_blank"
						rel="no noreferrer"
					>
						<Tooltip
							title="Partner Resource Center"
							placement="bottom"
						>
							<BookIcon />
							PRC
						</Tooltip>
					</a>
				</li>

				<li className={`${styles.logoHolder} ${styles.supportLogo}`}>
					<a
						href={URLS.toZendeskHelpCenter}
						className="d-block"
						target="_blank"
						rel="no noreferrer"
					>
						<QuestionIcon />
						Support
					</a>
				</li>
			</ul>
			<div className="d-flex flex-nowrap">
				<div className={styles.searchFormHolder}>
					<SearchForm />
				</div>

				<UserProfileBar />
			</div>
		</Container>
	</Navbar>
);

export default Header;
